import { render, staticRenderFns } from "./ViewerActionsDesign.vue?vue&type=template&id=4745e8ad&scoped=true"
import script from "./ViewerActionsDesign.vue?vue&type=script&lang=js"
export * from "./ViewerActionsDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerActionsDesign.vue?vue&type=style&index=0&id=4745e8ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4745e8ad",
  null
  
)

export default component.exports